import {
  IdentityField,
  TextFieldAdapter,
  AutocompleteAdapter,
  DatePickerAdapter
} from 'components/enhanced';
import {
  composeValidators,
  mustBeNumber,
  validMonthDay,
  validWeekDay
} from 'components/helpers/validators';
import { SectionHeader } from 'components/ui/typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const monthWeekOptions = [
  { id: 1, code: 'Settimana' },
  { id: 2, code: 'Mese' }
];

interface OrderFrequencyFieldsProps {
  programmed: boolean;
}

// Sotto-componente per la gestione delle ripetizioni / ordini programmati
export const OrderFrequencyFields = ({ programmed }: OrderFrequencyFieldsProps) => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.purchase-requests.new';
  const [frequencyOption, setFrequencyOption] = useState(monthWeekOptions.find((o) => o.id === 1));

  // Ascolta i cambiamenti sul tipo di frequenza scelto (Settimana o Mese)

  if (!programmed) return null;

  return (
    <>
      <SectionHeader
        title={t(`${translationPrefix}.programmed`)}
        subtitle={t(
          `${translationPrefix}.frequency-subtitle`,
          "Configura gli intervalli temporali e i giorni in cui l'ordine automatico deve essere generato."
        )}
        gridSpan
      />
      <IdentityField
        gridSpan={2}
        name="rep_frequency"
        component={TextFieldAdapter}
        label="Ripeti ogni"
        type="number"
        validate={composeValidators(mustBeNumber)}
      />
      <IdentityField
        name="rep_unit"
        component={AutocompleteAdapter}
        options={monthWeekOptions}
        setValue={setFrequencyOption}
        label="Mese/settimana"
        type="text"
      />
      <IdentityField
        name="day_of_month"
        component={TextFieldAdapter}
        label={frequencyOption.id === 1 ? 'Giorno della settimana' : 'Giorno del mese'}
        type="number"
        placeholder="1"
        validate={
          frequencyOption.id === 1
            ? composeValidators(validWeekDay)
            : composeValidators(validMonthDay)
        }
      />
      <IdentityField
        name="start_programmed"
        component={DatePickerAdapter}
        label={t('global.start')}
        type="date"
      />
      <IdentityField
        name="end_programmed"
        component={DatePickerAdapter}
        label={t('global.end')}
        type="date"
      />
    </>
  );
};
